import createStore from "astrid-helpers/src/createStore";
export const [getRipple, setRipple, useRipple] = createStore(false);
export const [getShouldRipple, setShouldRipple, useShouldRipple] = createStore(true);
//# sourceMappingURL=ripple.js.map